export const IPSPaymentlanguageoptions = [
    // ENGLISH
    {
        labels: [
            "Select Account",
            "Select Bank",
            "Beneficiary Account Number",
            "Amount",
            "Want To Tip?",
            "Tip",
            "Yes",
            "No",
            "Remark",
        ],
        button: "Pay",
        placeholder: [
            "Select Account",
            "Select bank",
            "Enter Beneficiary Account Number",
            "Enter Amount",
            "Enter Tip",
            "Enter Remark",
        ],
        valueError: [
            "Please Select account",
            "Please Select bank",
            "Please Enter Beneficiary Account Number",
            "Please Enter Amount",
            "Please Enter Remark",
            "Please enter a valid amount greater than zero",
        ],
    },

    // AMHARIC
    {
        labels: [
            "የተቀናሽ ሂሳብ",
            "የባንክ ዝርዝር",
            "የተቀባይ አካውንት ቁጥር",
            "መጠን",
            "ቲፕ ማድረግ ይፈልጋሉ?",
            "ቲፕ",
            "አዎ",
            "አይ",
            "አስተያየት",
        ],
        button: "ይክፈሉ",
        placeholder: [
            "የተቀናሽ ሂሳብ ቁጥር ይምረጡ",
            "የባንክ ዝርዝር ይምረጡ",
            "የተቀባይ አካውንት ቁጥር ያስገቡ",
            "መጠን ያስገቡ",
            "ቲፕ ያስገቡ",
            "አስተያየት ያስገቡ",
        ],
        valueError: [
            "እባክዎ የተቀናሽ ሂሳብ ቁጥር ይምረጡ",
            "እባክዎ የባንክ ዝርዝር ይምረጡ",
            "እባክዎ የተቀባይ አካውንት ቁጥር ያስገቡ",
            "እባክዎ መጠን ያስገቡ",
            "እባክዎ አስተያየት ያስገቡ",
            "እባክዎ ከዜሮ በላይ የሆነ ትክክለኛ መጠን ያስገቡ",
        ],
    },

    // OROMO
    {
        labels: [
            "Akkaawuntii filadhu",
            "Tarree baankii",
            "Akkaawontii itti ergamu",
            "Hamma",
            "Tip gochuu Barbaadduu?",
            "Tip",
            "Eeyyee",
            "Lakki",
            "Yaada",
        ],
        button: "Kaffali",
        placeholder: [
            "Lakk. Herragaa filadhu",
            "Tarree baankii filadhu",
            "Akkaawontii itti ergamu Galchaa",
            "Hamma Galchaa",
            "Tip Galchaa",
            "Yaada Galchaa",
        ],
        valueError: [
            "Maaloo Lakk. Herragaa filadhu",
            "Maaloo Tarree baankii Filadhu",
            "Maaloo Akkaawontii itti ergamu Galchaa",
            "Maaloo Hamma Galchaa",
            "Maaloo Yaada Galchaa",
            "Maaloo Hamma Sirrii ta'e Galchaa",
        ],
    },

    // TIGRE
    {
        labels: [
            "ኣካውንት ምረጽ",
            "ባንኪ ምሩጽ",
            "ናይ ተጠቃሚ ሕሳብ",
            "መጠን",
            "ቲፕ ክትህብ ትደሊ?",
            "መቅሹሽ",
            "እወ",
            "አይኮንን",
            "ርእይቶ ምሃብ",
        ],
        button: "ክፍሊት",
        placeholder: [
            "ኣካውንት ምረጽ",
            "ባንኪ ምረጹ",
            "ናይ ተጠቃሚ ሕሳብ ኣእቱ",
            "ዓቐን ኣእቱ",
            "ምኽሪ ኣእቱ",
            "ርእይቶ ምሃብ ኣእቱ",
        ],
        valueError: [
            "በጃኹም ኣካውንት ምረጹ",
            "በጃኹም ባንኪ ምረጹ",
            "በጃኹም ናይ ተጠቃሚ ሕሳብ ኣእትዉ",
            "በጃኹም መጠን ገንዘብ ኣእትዉ",
            "በጃኹም ርእይቶ ምሃብ ኣእትዉ",
            "በጃኹም ካ ዜሮ ዝበለ ትክክለኛ መጠን ኣእትው",
        ],
    },

    // SOMALE
    {
        labels: [
            "Dooro Koontada",
            "Dooro Bank",
            "Geli Cadadka",
            "Qaddarka",
            "Ma rabtaa inaad talo bixiso?",
            "Talo",
            "Haa",
            "Maya",
            "Odhaah",
        ],
        button: "Bixi",
        placeholder: [
            "Dooro Koontada",
            "Dooro bangiga",
            "Geli Cadadka",
            "Qiyaarta geli",
            "Gali Talo",
            "Gali hadalka",
        ],
        valueError: [
            "Fadlan dooro akoon",
            "Fadlan dooro bangiga",
            "Fadlan Geli Cadadka",
            "Fadlan geli qaddarka",
            "Fadlan geli Odhaah",
            "Fadlan geli tirada saxda ah",
        ],
    },
    // AFAR
    {
        labels: [
            "Akkaawonti meexa",
            "Midra meexa",
            "Yake gide",
            "Gide",
            "Fayso Faxxaa?",
            "Acwa",
            "Yeey",
            "Bale",
            "Mabla",
        ],
        button: "Mekla",
        placeholder: [
            "Akkaawonti meexa",
            "Midra meexa",
            "Yake gide culus",
            "Giddoo culus",
            "Fayyu Culus",
            "Mabla Culus",
        ],
        valueError: [
            "Kumaganah akkaawonti door",
            "Ku maganak midra doorit",
            "kumagan Yake gide culus",
            "Kumaganah Caddo culus",
            "Kumaganah Mabla culus",
            "ku magana sini faxxana lakqo ede cullussa'",
        ],
    },
];
